import { Auth } from '../amplify'
import { reportAuthProcessError } from './authDiagnostics'

export default function handleAuthProcessError(authErrorEvent) {
  const {
    message = 'An error occurred during authentication',
    data,
    shouldSignOut = true,
  } = authErrorEvent.payload || {}

  reportAuthProcessError(message, 'process_error')

  if (data instanceof Error) {
    console.error(message, data.stack)
  } else if (data) {
    console.log(`${message}: ${JSON.stringify(data, undefined, 4)}`)
  } else {
    console.log(message)
  }

  if (shouldSignOut) {
    Auth.signOut()
  }
}
